
import XHeader from 'vux/src/components/x-header/index.vue'
import querystring from 'vux/src/tools/querystring/index.js'


export default {
components: {
XHeader
},
data() {
return {
outlineTitle: "精华专区",
outlineData: ""
};
},
created() {
this.$vux.loading.show({
text: "请稍候..."
});

this.$http({
method: "post",
url: "wxexam.ashx?op=LoadCourseOutlineData",
params: {
outlineId: this.$route.query.id
}
})
.then(response => {
if (response.status == 200) {
if (response.data.data != null && response.data.data.length > 0) {
this.outlineTitle = response.data.data[0].coutlinename;
this.outlineData = response.data.data[0].ctext;
}
}
this.$vux.loading.hide();
})
.catch(function(error) {
console.log("error:" + error);
this.$vux.loading.hide();
});
},
methods: {}
};



// WEBPACK FOOTER //
// ./src/components/CourseOutlineData.vue